export default function Marquee() {
  const numbers = Array.from({ length: 13 }, (_, i) => i + 1)
  const marqueeNumber = Array.from({ length: 6 }, (_, i) => i + 1)

  return (
    <div className="marquees-container">
      {marqueeNumber.map(marqueeId => (
        <div key={marqueeId} className="marquee-pair-container">
          <div className="marquee-container">
            {numbers.map(numId => (
              <img
                key={`top-${marqueeId}-${numId}`}
                src={`./img/logo/logo${numId}.png`}
                alt="Logo entreprise ayant collaborée avec Maestrom"
              />
            ))}
          </div>
          <div className="marquee-container">
            {numbers.map(numId => (
              <img
                key={`bottom-${marqueeId}-${numId}`}
                src={`./img/logo/logo${numId}.png`}
                alt="Logo entreprise ayant collaborée avec Maestrom"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
